import React from "react";
import { RaisedButton } from "material-ui";

class TenantButton extends React.Component {
  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired
    };
  }

  render() {
    let { label, link, primary, openInNewTab, ...rest } = this.props;
    let linkEl, isSameDomain;

    // Ensure links to pages on the site don't trigger a page refresh
    if (link && !openInNewTab) {
      linkEl = document.createElement("a");
      linkEl.href = link;
      isSameDomain = linkEl.host === window.location.host;
    }

    return (
      <RaisedButton
        className="Eventive--TenantButton"
        label={label}
        primary={primary}
        href={!isSameDomain ? link : undefined}
        target={openInNewTab ? "_blank" : undefined}
        buttonStyle={{ verticalAlign: "baseline", whiteSpace: "nowrap" }}
        onClick={
          isSameDomain
            ? this.context.router.push.bind(
                this,
                linkEl.pathname + linkEl.search + linkEl.hash
              )
            : undefined
        }
        {...rest}
      />
    );
  }
}

export default TenantButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/tenant-button.jsx